import { render, staticRenderFns } from "./creative-details-modal.vue?vue&type=template&id=4b5f69ee&scoped=true"
import script from "./creative-details-modal.vue?vue&type=script&lang=js"
export * from "./creative-details-modal.vue?vue&type=script&lang=js"
import style0 from "./creative-details-modal.vue?vue&type=style&index=0&id=4b5f69ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f69ee",
  null
  
)

export default component.exports